export enum AccountSettingsPageTab {
    Preferences = 'preferences',
    Profile = 'my-profile',
    TaxCertManagement = 'tax-cert-management',
}

export type AccountSettingsPageQueryParams = {
    tab?: AccountSettingsPageTab;
};
